@for (ind of logIndexes; track ind) {
  <ng-container *ngIf="log[ind] as channelID">
    <ng-container *var="channelID | isLogArray | notificationsChannelById | async as channelBreadcrumbs">
      @if (channelID?.length === 3) {
        <!-- deleted data = [oldValue, 0, 0]-->
        <ng-container
          *ngTemplateOutlet="
              detailsContainer;
              context: {
                breadcrumbs: channelBreadcrumbs,
                type: ChangeLogsType.removed,
              }
            "
        ></ng-container>
      }

      @if (channelID?.length === 1) {
        <!-- added data = [newValue]-->
        <ng-container
          *ngTemplateOutlet="
              detailsContainer;
              context: {
                breadcrumbs: channelBreadcrumbs,
                type: ChangeLogsType.added,
              }
            "
        ></ng-container>
      }

      @if (!$last) {
        <span class="me-2">,</span>
      }
    </ng-container>
  </ng-container>
}

<ng-template #detailsContainer let-breadcrumbs="breadcrumbs" let-type="type">
  @for (channel of breadcrumbs; track $index) {
    @if (!$first) {
      <i class="dx-icon dx-icon-arrowright mx-1"></i>
    }
    <span
      [ngClass]="{'ag-change-log-detail--new-value': $last && type === ChangeLogsType.added, 'ag-change-log-detail--old-value': $last && type === ChangeLogsType.removed }">{{ channel }}</span>
  }
</ng-template>
